export default "__VITE_ASSET__DQVEGtEx__"